import { render, staticRenderFns } from "./PersonPage.vue?vue&type=template&id=7fdbce98&scoped=true"
import script from "./PersonPage.vue?vue&type=script&lang=js"
export * from "./PersonPage.vue?vue&type=script&lang=js"
import style0 from "./PersonPage.vue?vue&type=style&index=0&id=7fdbce98&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fdbce98",
  null
  
)

export default component.exports